import NoMatch from '@App/pages/NoMatch/NoMatch';
import Map from '@App/pages/Map/Map';

const routes = [
  {
    name: 'Page Not Found', 
    path: '*', 
    element: <NoMatch />,
  },
  {
    name: 'Map', 
    path: '/', 
    element: <Map />,
  },
  {
    name: 'Map', 
    path: '/download', 
    element: <Map />,
  },
];

export default routes;